'use es6';

import ActionTypes from './ActionTypes';
import { fetchAvailableLanguagesByTrackId } from '../features/tracks';
import { fetchAvailableLanguagesByLessonId } from '../api/LessonsApi';
export const availableLanuguagesByTrackIdRequesting = id => ({
  type: ActionTypes.AVAILABLE_LANGUAGES_BY_TRACK_ID_REQUESTING,
  meta: {
    id
  }
});
export const availableLanuguagesByTrackIdReceived = (id, payload) => ({
  type: ActionTypes.AVAILABLE_LANGUAGES_BY_TRACK_ID_RECEIVED,
  payload,
  meta: {
    id
  }
});
export const availableLanuguagesByTrackIdError = (id, payload) => ({
  type: ActionTypes.AVAILABLE_LANGUAGES_BY_TRACK_ID_ERROR,
  payload,
  meta: {
    id
  }
});
export const availableLanuguagesByLessonIdRequesting = id => ({
  type: ActionTypes.AVAILABLE_LANGUAGES_BY_LESSON_ID_REQUESTING,
  meta: {
    id
  }
});
export const availableLanuguagesByLessonIdReceived = (id, payload) => ({
  type: ActionTypes.AVAILABLE_LANGUAGES_BY_LESSON_ID_RECEIVED,
  payload,
  meta: {
    id
  }
});
export const availableLanuguagesByLessonIdError = (id, payload) => ({
  type: ActionTypes.AVAILABLE_LANGUAGES_BY_LESSON_ID_ERROR,
  payload,
  meta: {
    id
  }
});
export const getAvailableLanguagesByTrackId = trackId => dispatch => {
  dispatch(availableLanuguagesByTrackIdRequesting(trackId));
  const promise = fetchAvailableLanguagesByTrackId(trackId).then(response => dispatch(availableLanuguagesByTrackIdReceived(trackId, response)), errorResponse => dispatch(availableLanuguagesByTrackIdError(trackId, errorResponse)));
  promise.catch(err => {
    setTimeout(() => {
      throw err;
    });
  });
  return promise;
};
export const getAvailableLanguagesByLessonId = lessonId => dispatch => {
  dispatch(availableLanuguagesByLessonIdRequesting(lessonId));
  const promise = fetchAvailableLanguagesByLessonId(lessonId).then(response => dispatch(availableLanuguagesByLessonIdReceived(lessonId, response)), errorResponse => dispatch(availableLanuguagesByLessonIdError(lessonId, errorResponse)));
  promise.catch(err => {
    setTimeout(() => {
      throw err;
    });
  });
  return promise;
};